/*
 * @fileOverView ImageCaption component definition
 */

import Vue from 'vue';
import {KeyCodes} from 'utils/Constants';

Vue.component('imagecaption-vue', {
  data: function() {
    return {
      isExpanded: false
    }
  },
  computed: {
    linkIsTabbable: function () {
      return this.isExpanded ? 0 : -1
    }
  },
  methods: {
    handleIconKeydown: function (e) {
      if ([KeyCodes.ENTER, KeyCodes.SPACE].indexOf(e.keyCode) !== -1) {
        this.isExpanded = !this.isExpanded;
        e.preventDefault();

        // Focus the other icon.
        const focusEl = !this.isExpanded ? 'openToggle' : 'closeToggle';
        this.$nextTick(() => this.$refs[focusEl].focus());
      }
    }
  }
})
